import {IconButton} from '@wandb/components';
import React from 'react';

import {usePanelsQuickAddContext} from './PanelsQuickAddContext';

export const QuickAddHeader = () => {
  const {closeQuickAdd, onBack} = usePanelsQuickAddContext();
  return (
    <div className="px-24">
      <div className="flex items-center justify-between py-16">
        <IconButton
          variant="ghost"
          icon="back"
          aria-label="Back"
          onPress={onBack ?? closeQuickAdd}
        />
        <IconButton
          variant="ghost"
          icon="close"
          aria-label="Close"
          onPress={closeQuickAdd}
        />
      </div>
      <h2 className="text-xl font-semibold leading-[32px]">
        Quick panel builder
      </h2>
      <p className="text-moon-500">
        Use regex queries to quickly generate panels from keys.
      </p>
    </div>
  );
};
